import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { StoreIcon } from 'baby-design'

import LabelAndInfo from '../LabelAndInfo'
import css from './StoreInfo.styles.scss'

export type StoreInfoProps = {
  storeName: string | undefined | null
  storeIdentifier: string | undefined | null
}

const StoreInfo: FC<StoreInfoProps> = ({ storeName, storeIdentifier }) => {
  if (storeIdentifier === 'babylist') {
    return null
  }

  if (!storeName) {
    return (
      <LabelAndInfo info="Not provided" label="Store" variant="deemphasized" />
    )
  }

  if (!storeIdentifier) {
    return <LabelAndInfo info={storeName} label="Store" />
  }

  const info = (
    <div className={css.StoreInfo}>
      <StoreIcon store={{ name: storeIdentifier }} />
      {storeName}
    </div>
  )
  return <LabelAndInfo info={info} label="Store" />
}

export default StoreInfo
